/* global tealiumLink */

(($, Drupal, once) => {
  const initFormValidation = $form => {
    const fieldClass = 'form__element';
    const fieldErrorClass = `${fieldClass}__errors`;
    const $submit = $form.find(`.${fieldClass}--button`);
    let submitted = false;
    $submit.bind('drupalAjaxFormValidate', () => {
      $form.addClass('form--submitted');
      submitted = true;
      const valid = $form[0].checkValidity();
      if (!valid) {
        const invalidFields = {};
        $form
          .find(':invalid')
          .not('fieldset')
          .each(function cbEach(i) {
            const $this = $(this);
            if (i === 0) {
              $this.focus();
            }

            const type = $this.attr('type');
            let $parent;
            if (type === 'radio' || type === 'checkbox') {
              $parent = $this
                .parent()
                .parent()
                .parent()
                .parent();
            } else {
              $parent = $this.parent();
            }

            invalidFields[$this.attr('name')] = $parent
              .find(`.${fieldErrorClass}`)
              .text();
          });

        const fieldNames = Object.keys(invalidFields);

        tealiumLink({
          formErrors: fieldNames.map(key => invalidFields[key]).join('|'),
          form_fieldname: fieldNames.join('|'),
        });
      }
      if (valid) {
        const formPassedAsValidEvent = $.Event('drupalAjaxFormPassedAsValid');
        $($submit[0]).trigger(formPassedAsValidEvent);
      }
      return valid;
    });

    const $inputs = $form.find(`.${fieldClass}__input`);

    $inputs.each(function cbEach() {
      const $this = $(this);
      const type = $this.attr('type');

      let errorValueMissing;
      let errorInvalid;

      let $parent = $this.parent();
      if (type === 'radio' || type === 'checkbox') {
        $parent = $this
          .parent()
          .parent()
          .parent()
          .parent();

        errorValueMissing = $parent.attr('data-error-value-missing');
        errorInvalid = $parent.attr('data-error-invalid');
      } else {
        $parent = $this.parent();
        errorValueMissing = $this.attr('data-error-value-missing');
        errorInvalid = $this.attr('data-error-invalid');
      }

      $this.bind('input', () => {
        if (submitted) {
          $this[0].checkValidity();
        }
      });

      if (type === 'radio') {
        $this.bind('change', () => {
          if (submitted) {
            $parent.toggleClass('invalid', !$this[0].checkValidity());
          }
        });
      }

      let $error = $parent.find(`.${fieldErrorClass}`);
      if (!$error.length) {
        $error = $(
          `<div class="${fieldErrorClass} ${fieldErrorClass}--client" id="${$this.attr(
            'aria-describedby'
          )}"></div>`
        ).appendTo($parent);
      }

      $this.bind('invalid', e => {
        let message;
        if (type === 'radio') {
          $parent.addClass('invalid');
        }

        if (!$this[0].validity.valueMissing) {
          message = errorInvalid || (message = $this[0].validationMessage);
        } else {
          message = errorValueMissing || (message = $this[0].validationMessage);
        }
        $error.text(message);
        e.preventDefault();
      });
    });
  };

  Drupal.behaviors['form-validation'] = {
    // Make the 50-50 Slider paragraph work.
    attach: context => {
      const webformClass = 'webform-submission-form';
      $(once('form-validation', `.${webformClass}`, context))
        .each(function cbEach() {
          initFormValidation($(this));
        });
    },
  };
})(jQuery, Drupal, once);
